// extracted by mini-css-extract-plugin
export default {"noPermission":"noPermission---uJ1nL"};